import { isArray, isEmpty, trim, getByteLen } from '@/common/js/utils'

export default {
  methods: {
    invalid (rules) {
      const arr = []
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? this[rule.name.split('/')[0]][rule.name.split('/')[1]] : this[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string' && !rule.charset) {
          param = trim(ruleName)
          length = getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else if (typeof ruleName === 'string' && rule.charset === 'bc') {
          param = ruleName
          length = String(param).length
        } else if (typeof ruleName === 'number') {
          param = length = ruleName
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? this[rule.relyon.split('/')[0]][rule.relyon.split('/')[1]] : this[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if (rule.require && isEmpty(param)) {
          const msg = `${rule.desc}不能为空`
          this.formErr = true
          arr.push({ feild: rule.desc, msg })
          continue
        }

        // 长度判断
        if (typeof param === 'string' || isArray(param)) {
          if (param && rule.max < length) {
            const msg = `${rule.desc}不能多于${rule.max}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (param && rule.min > length) {
            const msg = `${rule.desc}不能少于${rule.min}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }

        // 大小判断
        if (typeof param === 'number') {
          if (rule.max < length) {
            const msg = `${rule.desc}数值不能大于${rule.max}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (rule.min > length) {
            const msg = `${rule.desc}数值不能小于${rule.min}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }

        // 正则
        if (rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }
      return arr
    }
  }
}
